import React, { Fragment, useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import {get, update, getMany, set} from 'idb-keyval'

export default function Clpt()
{
    
}